import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PolicyDetailsCommercialPropertyCauseOfLossClient, PolicyDetailsCommercialPropertyCauseOfLossModel, PolicyDetailsCommercialPropertyCauseOfLossRefModel } from '../../../../../client/ApiClient';
import { DataCell, DataRow, DataTable } from '../../../../basic/DataTable';
import { paginate, RangePaginationState, RangePagination } from '../../../../basic/Pagination';
import { stagingPageCopyMappings, StagingPageCopyMappingsItem } from '../generic/Abstractions'
import { DropdownMenu, DropdownToggle, Input, UncontrolledDropdown, DropdownItem } from 'reactstrap';
import StageActionToolbar from '../generic/StageActionToolbar';
import { RowStatus, AssignRowStatus } from '../generic';
import { enqueueNotification } from "../../../../../store/Notifications"
import { store } from "AppContext"
import DataListInput from '../../../../basic/DataListInput';
import { filterColumns, sort } from '../generic/EntityFunctions';

interface PolicyDetailsCommercialPropertyCauseOfLossStagingPageArgs {
    conversionId: string,
}


type PolicyDetailsCommercialPropertyCauseOfLossStagingPageProps =
    RouteComponentProps<PolicyDetailsCommercialPropertyCauseOfLossStagingPageArgs>;



interface PolicyDetailsCommercialPropertyCauseOfLossStagingPageState {
    items: (PolicyDetailsCommercialPropertyCauseOfLossModel
        & StagingPageCopyMappingsItem)[];
    destinationCodes: PolicyDetailsCommercialPropertyCauseOfLossRefModel[];
    filter: string;
    sort: boolean;
    sortColumn: string;
    mapped: boolean;
    notMapped: boolean;
    lastValue: string;
    dropDownIndex: number | null;
    pagination: RangePaginationState;
    buttonLock: boolean;
    filteredColumn: string;
}


export class PolicyDetailsCommercialPropertyCauseOfLossStagingPage extends React.Component<PolicyDetailsCommercialPropertyCauseOfLossStagingPageProps, PolicyDetailsCommercialPropertyCauseOfLossStagingPageState>{
    private client: PolicyDetailsCommercialPropertyCauseOfLossClient = new PolicyDetailsCommercialPropertyCauseOfLossClient()

    private readonly copyMappings = stagingPageCopyMappings(this);

    constructor(props: PolicyDetailsCommercialPropertyCauseOfLossStagingPageProps) {
        super(props)
        this.state = {
            items: [],
            destinationCodes: [],
            filter: '',
            sort: true,
            sortColumn: '',
            mapped: true,
            notMapped: true,
            lastValue: '',
            dropDownIndex: null,
            pagination: {
                pageSize: 25,
                pageNumber: 0,
            },
            buttonLock: true,
            filteredColumn: '',
        }
    }

    componentDidMount() {
        this.getItems();

        this.client.getRef(this.props.match.params.conversionId)
            .then(response => {
                if (response != null) {
                    this.setState({
                        destinationCodes: response,
                    })
                }
            })
            .catch(error => { console.log(error) })
    }

    setDefaults = (entity: PolicyDetailsCommercialPropertyCauseOfLossModel) => new PolicyDetailsCommercialPropertyCauseOfLossModel({
        ...entity,
        destinationCode: entity.destinationCode || '',
    })

    getItems = () => {
        this.client.getAll(this.props.match.params.conversionId, '')
            .then((response) => {
                this.setState({
                    items: sort(response!.map(this.setDefaults), this.state.sortColumn, this.state.sort, [])
                })
            })
            .catch(error => { console.log(error) })
    }

    put(entity: PolicyDetailsCommercialPropertyCauseOfLossModel) {
        this.client.put(this.props.match.params.conversionId, entity)
            .then(() => {
                this.getItems()
                store.dispatch(enqueueNotification({ type: 'success', message: `Cause of Loss ${entity.sourceCode} was saved.` }))
            })
            .catch((error) => {
                console.log(error)
                const response = JSON.parse(error.response)
                store.dispatch(enqueueNotification({ type: 'error', message: response }))
            });
    }

    handleSearch = (filter: string) => {
        this.setState({ filter })
    }

    sort(column: string) {
        const sorted = this.state.sortColumn === column ? !this.state.sort : true;
        const items = sort(this.state.items, column, sorted, [])
        this.setState({ sort: sorted, sortColumn: column, items });
    }

    mappedCheck(check: string) {
        if (check === 'notMapped') {
            const notMapped = !this.state.notMapped
            this.setState({ notMapped })
        } else if (check === 'mapped') {
            const mapped = !this.state.mapped
            this.setState({ mapped })
        }
    }

    lockButton = (lock: boolean) => {
        this.setState({ buttonLock: lock })
    }

    handleChangeDropDown = (item: PolicyDetailsCommercialPropertyCauseOfLossModel, e: any) => {
        const i = this.state.items.findIndex(v => v.id === item.id);
        const items = this.state.items.map(
            v => v.id === item.id
                ? new PolicyDetailsCommercialPropertyCauseOfLossModel({
                    ...v,
                    destinationCode: e.value
                })
                : v
        )
        this.setState({ items });
        if (item.destinationCode?.trim() !== items[i].destinationCode?.trim()) this.put(items[i])
    }

    DestinationCodes = (): any[] => {
        const arr = [];
        const dc = this.state.destinationCodes;
        for (let i = 0; i < dc.length; i++) {
            arr.push(<option
                key={i}
                data-value={dc[i].sourceCode}
            >
                {`${dc[i].sourceCode!.trim()} - ${dc[i].sourceDescription}`}
            </option>)
        }
        return arr;
    }

    selectFilteredColumn = (filteredColumn: string) => {
        this.setState({ filteredColumn })
    }

    public render() {
        const conversionId = this.props.match.params.conversionId;
        const filteredColumn = this.state.filteredColumn;
        const items = this.state.items
            .map(AssignRowStatus)
            .filter(i => ((filteredColumn === '' || filteredColumn === 'sourceCode') && i.sourceCode && i.sourceCode!.toLowerCase().includes(this.state.filter.trim().toLowerCase())) ||
                ((filteredColumn === '' || filteredColumn === 'sourceDescription') && i.sourceDescription && i.sourceDescription!.toLowerCase().includes(this.state.filter.trim().toLowerCase())) ||
                ((filteredColumn === '' || filteredColumn === 'destinationCode') && i.destinationCode && i.destinationCode!.toLowerCase().includes(this.state.filter.trim().toLowerCase())) ||
                ((filteredColumn === '' || filteredColumn === 'destinationDescription') && i.destinationDescription && i.destinationDescription!.toLowerCase().includes(this.state.filter.trim().toLowerCase())))
            .filter(item =>
                (item.mapped === RowStatus.NotMapped && this.state.notMapped)
                || (item.mapped === RowStatus.Mapped && this.state.mapped));

        return (
            <>
                <StageActionToolbar
                    conversionId={conversionId}
                    sectionId='cp'
                    sectionType='causeofloss'
                    tierGate='tier4'
                    handleSearch={this.handleSearch}
                    handleCopyMapping={this.copyMappings.submitMappings}
                    filter={this.state.filter}
                    copyMap={true}
                    getItems={this.getItems}
                    lockButton={this.lockButton}
                    filterColumns={filterColumns(items)}
                    selectFilteredColumn={this.selectFilteredColumn}
                />
                <DataTable>
                    <thead>
                        <tr className='nonFullWidthRow'>
                            <th onClick={() => this.sort('sourceCode')}>Source Code<i className="fa fa-sort"></i></th>
                            <th onClick={() => this.sort('sourceDescription')}>Source Description<i className="fa fa-sort"></i></th>
                            <th onClick={() => this.sort('destinationCode')}>Destination Code<i className="fa fa-sort"></i></th>
                            <th className='checkbox-column'>
                                <UncontrolledDropdown setActiveFromChild className="ismappedDropdown">
                                    <DropdownToggle tag="a" className="ismapped" caret>
                                        Mapped
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem className={!this.state.notMapped ? 'mappedChecked' : ''} onClick={() => this.mappedCheck('notMapped')}>&#x274C; Not Mapped</DropdownItem>
                                        <DropdownItem className={!this.state.mapped ? 'mappedChecked' : ''} onClick={() => this.mappedCheck('mapped')}>&#x2705; Mapped</DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </th>
                            <th onClick={() => this.sort('isUserMapped')} className='checkbox-column'>Auto-Mapped<i className="fa fa-sort"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            paginate(items, this.state.pagination, (item, index) => (
                                <DataRow id={item.id.toString()} key={item.id}>
                                    <DataCell>{item.sourceCode}</DataCell>
                                    <DataCell>{item.sourceDescription}</DataCell>
                                    <DataCell>
                                        {index === this.state.dropDownIndex ?
                                            <>
                                                <DataListInput
                                                    id={`referenceId - ${index}`}
                                                    name={item.id.toString()}
                                                    value={item.destinationCode ? item.destinationCode : undefined}
                                                    onValueChange={event => this.handleChangeDropDown(item, event)}
                                                    disabled={this.state.buttonLock}
                                                >
                                                    <option data-value='' />
                                                    {this.DestinationCodes()}
                                                </DataListInput>
                                            </>
                                            :
                                            <Input
                                                value={item.destinationCode ? `${item.destinationCode} - ${item.destinationDescription}` : ''}
                                                onFocus={() => this.setState({ dropDownIndex: index })}
                                                onBlur={() => this.setState({ dropDownIndex: null })}
                                                disabled={this.state.buttonLock}
                                            />}
                                    </DataCell>
                                    <DataCell className='checkbox-column' itemProp={item.mapped === RowStatus.NotMapped ? 'unmapped' : item.mapped === RowStatus.Mapped ? 'mapped' : 'dropped'}>
                                        {item.mapped === RowStatus.NotMapped ? < span className='mapped' itemProp='unmapped'>&#x274C;</span> : item.mapped === RowStatus.Mapped ? < span className='mapped' itemProp='mapped'>&#x2705;</span> : < span className='mapped' itemProp='dropped'>&#x2796;</span>}
                                    </DataCell>
                                    <DataCell
                                        className='checkbox-column'
                                        itemProp={!item.isUserMapped && item.isMapped ? 'auto-mapped' : ''}
                                    >
                                        {!item.isUserMapped && item.isMapped ? < span className='mapped' itemProp='auto-mapped'>&#x2705;</span> : ''}
                                    </DataCell>
                                </DataRow>
                            ))
                        }
                    </tbody>
                </DataTable>
                <RangePagination
                    pageNumber={this.state.pagination.pageNumber}
                    pageSize={this.state.pagination.pageSize}
                    recordsCount={items.length}
                    onChangeIndex={index => this.setState({
                        pagination: {
                            ...this.state.pagination,
                            pageNumber: index,
                        }
                    })}
                />
            </>
        );
    }
}